<template>
  <div></div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-ratings-write-review-auto-view',
  data() {
    /* istanbul ignore next */
    return {
      vueSliderRtl: 'ltr',
    };
  },
  created() {
    setTimeout(function () {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == 'rr-write-review') {
          /* istanbul ignore next */
          eventBus.emit('show-write-review');
          eventBus.emit('focus-ratings-tab');
          window.location.hash = '#ratings';
          this.$scrollTo('#ratings');
          document.querySelector('#ratings')?.focus({ preventScroll: true });
        }
      }
    }, 1000);
  },
  methods: {
    autoFocusReview() {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == 'rr-write-review') {
          /* istanbul ignore next */
          eventBus.emit('show-write-review');
          eventBus.emit('focus-ratings-tab');
          window.location.hash = '#ratings';
          this.$scrollTo('#ratings');
          document.querySelector('#ratings')?.focus({ preventScroll: true });
        }
      }
    },
  },
};
</script>
